import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";
import { CreateTextMaskCustom } from "./controlPhone";

export interface ControlZipProps extends ControlTemplateProps {

}

const maskedZipField = CreateTextMaskCustom([/\d/, /\d/, /\d/, /\d/, /\d/]);

export const ControlZip: React.FC<ControlZipProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ?? useControlStyles();

    return (
        <ControlInput
            type="text"
            {...ComponentProps(props)}
            tag={maskedZipField}
            style={{ ...styles.number ?? styles.text ?? styles.input, ...props.style }} />
    );
};